import { useAppContext } from '../../core/context';
import { Brand, getBrandFromQueryParamOrClaimsOrHost } from '../../core/context/claims';

interface Props {
  className?: string;
}

function OnlineShoppingIllustration({ className }: Props): React.ReactNode {
  const context = useAppContext();
  const brand = getBrandFromQueryParamOrClaimsOrHost(context.claims);

  if (brand === Brand.VIPPS) {
    return (
      <svg
        className={className}
        width="300"
        height="300"
        viewBox="0 0 300 300"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="150" cy="150" r="100" fill="#EFEEF3" />
        <path
          fill="#39134C"
          d="M246.497 177.497A100.31 100.31 0 0 1 150 250.421a100.304 100.304 0 0 1-96.497-72.924 96.093 96.093 0 0 1 95.954-91.104h1.086a96.094 96.094 0 0 1 95.954 91.104"
        />
        <path
          fill="#AEAABF"
          d="M150 85.133h-28.132a9.874 9.874 0 0 0-9.874 9.874 9.88 9.88 0 0 0 6.089 9.148c1.2.498 2.486.754 3.785.754H150zM150.295 104.907h28.132a9.864 9.864 0 0 0 9.865-9.865 9.87 9.87 0 0 0-2.886-6.981 9.86 9.86 0 0 0-6.979-2.893h-28.132z"
        />
        <path
          d="m149.162 83.927 1.657-7.298M151.795 84.156l4.141-5.31"
          stroke="#AEAABF"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="3.009"
        />
        <path
          fill="#FFD3BB"
          d="M150 166.74c23.099 0 41.825-18.726 41.825-41.825S173.099 83.09 150 83.09s-41.825 18.726-41.825 41.825S126.901 166.74 150 166.74"
        />
        <path
          fill="#FFD3BB"
          d="M185.457 98.236h-70.914a4.24 4.24 0 0 0-4.242 4.238 4.24 4.24 0 0 0 4.242 4.238h70.914a4.24 4.24 0 0 0 4.243-4.238 4.24 4.24 0 0 0-4.243-4.238"
        />
        <path
          fill="#AEAABF"
          d="M163.15 123.994a1.78 1.78 0 0 0 1.618-1.055 1.78 1.78 0 0 0-.302-1.908 19.35 19.35 0 0 0-6.534-4.809 19.34 19.34 0 0 0-15.865 0 19.3 19.3 0 0 0-6.534 4.809 1.78 1.78 0 0 0-.302 1.908 1.78 1.78 0 0 0 1.618 1.055z"
        />
        <path fill="#FFD3BB" d="M146.024 104.834h7.951v9.202a3.975 3.975 0 1 1-7.951 0z" />
        <path
          stroke="#722AC9"
          strokeMiterlimit="10"
          strokeWidth="1.417"
          d="M146.098 111.23a14.7 14.7 0 0 1 7.803 0"
        />
        <path
          stroke="#722AC9"
          strokeMiterlimit="10"
          strokeWidth="1.417"
          d="M142.923 115.417a3.25 3.25 0 1 0-.001-6.499 3.25 3.25 0 0 0 .001 6.499ZM157.077 115.417a3.249 3.249 0 1 0-.001-6.497 3.249 3.249 0 0 0 .001 6.497Z"
        />
        <path
          fill="#39134C"
          d="M146.761 105.929a1.343 1.343 0 1 0 0-2.685 1.343 1.343 0 0 0 0 2.685M153.239 105.929a1.343 1.343 0 1 0 .001-2.687 1.343 1.343 0 0 0-.001 2.687"
        />
        <path fill="#FF5B24" d="M233.843 205.076a100.306 100.306 0 0 1-167.687 0z" />
        <path
          fill="#FFD3BB"
          d="M211.095 205.076h-25.574v-19.325h6.286a19.33 19.33 0 0 1 19.325 19.325zM108.194 185.789h6.285v19.325H88.905a19.325 19.325 0 0 1 19.289-19.325"
        />
        <path
          fill="#AEAABF"
          d="M112.27 151.389h75.46a6.049 6.049 0 0 1 6.055 6.055v47.632h-87.57v-47.632a6.049 6.049 0 0 1 6.055-6.055"
        />
        <path fill="#fff" d="M150 185.788a5.273 5.273 0 1 0 0-10.547 5.273 5.273 0 0 0 0 10.547" />
        <path fill="#39134C" d="M161.963 126.074a4.602 4.602 0 0 1-9.202 0z" />
        <path fill="#FF985F" d="M261.35 166.564h-36.81v38.651h36.81z" />
        <path
          fill="#FF5B24"
          d="M224.54 166.564h-12.884v38.651h12.884zM247.546 166.564h-9.202v19.326h9.202z"
        />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      width="300"
      height="300"
      viewBox="0 0 300 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="var(--redesign-illustration-bg)"
        d="M150 250c55.228 0 100-44.772 100-100S205.228 50 150 50 50 94.772 50 150s44.772 100 100 100"
      />
      <mask id="a" width="200" height="200" x="50" y="50" maskUnits="userSpaceOnUse">
        <path
          fill="#fff"
          d="M150 250c55.228 0 100-44.772 100-100S205.228 50 150 50 50 94.772 50 150s44.772 100 100 100"
        />
      </mask>
      <g mask="url(#a)">
        <path
          fill="var(--redesign-illustration-primary)"
          d="M246.82 177.081a100.307 100.307 0 0 1-96.5 72.92c-21.83 0-43.06-7.12-60.48-20.28a100.27 100.27 0 0 1-36.02-52.64 96.07 96.07 0 0 1 29.8-64.7 96.14 96.14 0 0 1 66.16-26.41h1.09c24.62 0 48.3 9.45 66.15 26.41a96.12 96.12 0 0 1 29.8 64.7"
        />
        <path
          fill="var(--redesign-illustration-muted)"
          d="M150.32 84.711h-28.13c-1.3 0-2.58.26-3.78.75-1.2.5-2.29 1.22-3.2 2.14s-1.64 2.01-2.14 3.2c-.5 1.2-.75 2.48-.75 3.78s.25 2.59.74 3.79 1.22 2.29 2.14 3.21 2.01 1.65 3.21 2.15 2.49.75 3.78.75h28.13v-19.78zM150.62 104.49h28.13a9.87 9.87 0 0 0 9.86-9.87c0-1.3-.25-2.58-.75-3.78s-1.22-2.29-2.14-3.2c-.92-.92-2-1.64-3.2-2.14s-2.48-.75-3.78-.75h-28.13v19.74z"
        />
        <path
          d="M149.48 85.01c-.11 0-.22-.01-.33-.04-.81-.18-1.32-.99-1.13-1.8l1.66-7.3c.18-.81.99-1.32 1.8-1.13.81.18 1.32.99 1.13 1.8l-1.66 7.3c-.16.7-.78 1.17-1.47 1.17"
          fill="var(--redesign-illustration-muted)"
        />
        <path
          fill="var(--redesign-illustration-muted)"
          d="M152.121 85.242c-.32 0-.65-.1-.92-.32a1.5 1.5 0 0 1-.26-2.11l4.14-5.31a1.5 1.5 0 0 1 2.11-.26c.66.51.77 1.46.26 2.11l-4.14 5.31c-.3.38-.74.58-1.19.58"
        />
        <path
          fill="var(--redesign-illustration-skin)"
          d="M150.32 166.322c23.1 0 41.82-18.73 41.82-41.82s-18.73-41.83-41.82-41.83-41.82 18.73-41.82 41.83 18.73 41.82 41.82 41.82"
        />
        <path
          fill="var(--redesign-illustration-skin)"
          d="M185.78 97.82h-70.91c-2.34 0-4.24 1.9-4.24 4.24s1.9 4.24 4.24 4.24h70.91c2.34 0 4.24-1.9 4.24-4.24s-1.9-4.24-4.24-4.24"
        />
        <path
          fill="var(--redesign-illustration-muted)"
          d="M163.47 123.572c.34 0 .68-.1.97-.29s.51-.45.65-.77c.14-.31.18-.66.13-1s-.2-.65-.43-.91a19.25 19.25 0 0 0-6.53-4.81 19.36 19.36 0 0 0-15.86 0 19.25 19.25 0 0 0-6.53 4.81c-.23.26-.38.57-.43.91s0 .68.13 1c.14.31.37.58.65.77.29.19.62.29.96.29h26.3z"
        />
        <path
          fill="var(--redesign-illustration-skin)"
          d="M146.351 104.41h7.95v9.2c0 1.05-.42 2.06-1.16 2.81-.75.75-1.76 1.16-2.81 1.16a4 4 0 0 1-2.81-1.16 3.97 3.97 0 0 1-1.16-2.81v-9.2z"
        />
        <path
          fill="var(--redesign-illustration-detail)"
          d="M154.04 111.491c-2.43-.67-5-.67-7.43 0l-.38-1.37c2.68-.74 5.5-.74 8.18 0l-.38 1.37z"
        />
        <path
          fill="var(--redesign-illustration-detail)"
          d="M143.24 115.701c-2.18 0-3.96-1.77-3.96-3.96s1.78-3.96 3.96-3.96a3.97 3.97 0 0 1 3.96 3.96 3.97 3.97 0 0 1-3.96 3.96m0-6.5c-1.4 0-2.54 1.14-2.54 2.54s1.14 2.54 2.54 2.54 2.54-1.14 2.54-2.54-1.14-2.54-2.54-2.54M157.4 115.701c-2.18 0-3.96-1.77-3.96-3.96s1.78-3.96 3.96-3.96a3.97 3.97 0 0 1 3.96 3.96 3.97 3.97 0 0 1-3.96 3.96m0-6.5c-1.4 0-2.54 1.14-2.54 2.54s1.14 2.54 2.54 2.54 2.54-1.14 2.54-2.54-1.14-2.54-2.54-2.54"
        />
        <path
          fill="var(--redesign-illustration-ink)"
          d="M147.08 105.51a1.34 1.34 0 1 0 0-2.68 1.34 1.34 0 0 0 0 2.68M153.561 105.51a1.34 1.34 0 1 0 0-2.68 1.34 1.34 0 0 0 0 2.68"
        />
        <path
          fill="var(--redesign-illustration-ink-alt)"
          d="M234.16 204.66a100.31 100.31 0 0 1-83.85 45.24c-16.63 0-33-4.14-47.64-12.03a100.3 100.3 0 0 1-36.21-33.21h167.7"
        />
        <path
          fill="var(--redesign-illustration-skin)"
          d="M211.421 204.662h-25.57v-19.32h6.29c5.12 0 10.04 2.04 13.66 5.66s5.66 8.54 5.66 13.66zM108.52 185.371h6.28v19.33H89.23a19.3 19.3 0 0 1 5.65-13.65c3.62-3.62 8.52-5.66 13.64-5.67z"
        />
        <path
          fill="var(--redesign-illustration-secondary)"
          d="m112.98 150.43 75.45 1.08c.79.01 1.58.18 2.31.49.73.32 1.39.77 1.95 1.34.55.57.99 1.24 1.28 1.98s.44 1.53.43 2.32c.19 15.67.37 31.34.56 47.01-29.6.01-59.19.02-88.79.04.22-16.1.45-32.19.67-48.29a6.067 6.067 0 0 1 1.83-4.26c.57-.55 1.24-.99 1.98-1.28a6.2 6.2 0 0 1 2.32-.43z"
        />
        <path
          fill="var(--redesign-illustration-surface)"
          d="M150.321 185.37a5.27 5.27 0 1 0-.001-10.541 5.27 5.27 0 0 0 .001 10.541"
        />
        <path
          fill="var(--redesign-illustration-ink)"
          d="M162.28 125.65c0 1.22-.49 2.39-1.35 3.25s-2.03 1.35-3.25 1.35-2.39-.49-3.25-1.35a4.6 4.6 0 0 1-1.35-3.25z"
        />
        <path fill="var(--redesign-illustration-highlight)" d="M247.87 166.141h-9.2v19.33h9.2z" />
      </g>
      <path fill="var(--redesign-illustration-highlight)" d="M247.95 165.98h-9.29v19.51h9.29z" />
      <path
        fill="var(--redesign-illustration-muted)"
        d="M226.98 165.98h-12.86a2.07 2.07 0 0 0-2.07 2.07v34.89a2.07 2.07 0 0 0 2.07 2.07h12.86a2.07 2.07 0 0 0 2.07-2.07v-34.89a2.07 2.07 0 0 0-2.07-2.07"
      />
      <path
        fill="var(--redesign-illustration-secondary)"
        d="M261.23 165.98h-33.99a2.52 2.52 0 0 0-2.52 2.52v33.99a2.52 2.52 0 0 0 2.52 2.52h33.99a2.52 2.52 0 0 0 2.52-2.52V168.5a2.52 2.52 0 0 0-2.52-2.52"
      />
      <path
        fill="var(--redesign-illustration-muted)"
        d="M247.79 165.98h-8.97a1.44 1.44 0 0 0-1.44 1.44v24.33c0 .796.645 1.44 1.44 1.44h8.97a1.44 1.44 0 0 0 1.44-1.44v-24.33a1.44 1.44 0 0 0-1.44-1.44"
      />
    </svg>
  );
}

export default OnlineShoppingIllustration;
